import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetUserProfile } from '../../store/features/Auth/UserProfileSlice'
import { resetMenuItems } from '../../store/features/Auth/MenuItemsSlice'
import { resetCatClientes } from '../../store/features/Catalogos/CatClientesSlice'

interface IProps {}

export const Logout: FC<IProps> = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    /*  localStorage.getItem('tokenInfo')
    localStorage.getItem('token')
    localStorage.removeItem('menu') */
    localStorage.clear()
    dispatch(resetUserProfile(''))
    dispatch(resetMenuItems(''))
    dispatch(resetCatClientes(''))
    navigate('/', { replace: true })
  }, [])

  return <div>Logout</div>
}
